<template>
  <div class="us_app">
    <section class="user_section">
      <div class="title jc">
        <h2>코끼리 비방사전 상세정보</h2>
      </div>

      <article class="view">
        <div class="table_list">
          <h3 class="tb_title">기본 정보</h3>
          <table class="write">
            <colgroup>
              <col width="200" />
              <col width="30%" />
              <col width="200" />
              <col width="30%" />
            </colgroup>
            <tbody>
              <tr>
                <th>질병 카테고리</th>
                <td>
                  <span>{{formulaLibraryInfo.prescribe_category_nm}}</span>
                </td>
                <th>질병 상세 카테고리</th>
                <td><span>{{formulaLibraryInfo.prescribe_sub_category_nm}}</span></td>
              </tr>
              <tr>
                <th>처방명</th>
                <td>
                  <span>{{formulaLibraryInfo.prescribe_nm}}</span>
                </td>
                <th>등록자</th>
                <td><span>{{formulaLibraryInfo.nick_nm}}</span></td>
              </tr>
              <tr>
                <th>출처</th>
                <td>
                  <span>{{formulaLibraryInfo.prescribe_source}}</span>
                </td>
                <td colspan="2"></td>
              </tr>
              <tr>
                <th>적응중</th>
                <td colspan="3">
                  <span>{{formulaLibraryInfo.indications}}</span>
                </td>
              </tr>
              <tr>
                <th>사용 기준</th>
                <td colspan="3">
                  <div class="flex gap8 items-center">
                    <span v-if="formulaLibraryInfo.usage_criteria_day != ''">{{formulaLibraryInfo.usage_criteria_day}}일분</span>
                     <span v-if="formulaLibraryInfo.usage_criteria_dose != ''">{{formulaLibraryInfo.usage_criteria_dose}}첩</span>
                     <span v-if="formulaLibraryInfo.usage_criteria_pack != ''">{{formulaLibraryInfo.usage_criteria_pack}}팩 </span>
                     <span v-if="formulaLibraryInfo.usage_criteria_unit != ''">{{formulaLibraryInfo.usage_criteria_unit}}ml</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table_list">
          <h3 class="tb_title">환자 증상</h3>
          <table class="write">
            <colgroup>
              <col width="12.5%" />
              <col width="12.5%" />
              <col width="12.5%" />
              <col width="12.5%" />
            </colgroup>
            <tbody>
            <tr>
              <th>성별</th>
              <td colspan="3">
                <span>{{formulaLibraryInfo.gender_nm}}</span>
              </td>
            </tr>
            <tr>
              <th>체질과의 연관성</th>
              <td colspan="3">
                <span>{{formulaLibraryInfo.constitutionImpact_nm}}</span>
              </td>
            </tr>
            <tr>
              <th>사상체질</th>
              <td colspan="3">
                <span>{{formulaLibraryInfo.constitution_nm}}</span>
              </td>
            </tr>
            <tr>
              <th>한열타입</th>
              <td colspan="3">
                <span>{{formulaLibraryInfo.thermal_status_nm}}</span>
              </td>
            </tr>
            <tr>
              <th>체력상태</th>
              <td colspan="3">
                <span>{{formulaLibraryInfo.physical_condition_nm}}</span>
              </td>
            </tr>
            <tr>
              <th>긴장상태</th>
              <td colspan="3">
                <span>{{formulaLibraryInfo.tension_status_nm}}</span>
              </td>
            </tr>
            <tr>
              <th>예민도</th>
              <td colspan="3">
                <span>{{formulaLibraryInfo.sensitivity_nm}}</span>
              </td>
            </tr>
            <tr>
              <th>갈증상태</th>
              <td colspan="3">
                <span>{{formulaLibraryInfo.thirst_status_nm}}</span>
              </td>
            </tr>
            <tr>
              <th>수면상태</th>
              <td colspan="3">
                <span>{{formulaLibraryInfo.sleep_status_nm}}</span>
              </td>
            </tr>
            <tr>
              <th>대변상태</th>
              <td colspan="3">
                <span>{{formulaLibraryInfo.bowel_status_nm}}</span>
              </td>
            </tr>
            <tr>
              <th>잔변감</th>
              <td colspan="3">
                <span>{{formulaLibraryInfo.residualStoolSense_nm}}</span>
              </td>
            </tr>
            <tr>
              <th>소화상태</th>
              <td colspan="3">
                <span>{{formulaLibraryInfo.digestive_status_nm}}</span>
              </td>
            </tr>
            <tr>
              <th>식욕상태</th>
              <td colspan="3">
                <span>{{formulaLibraryInfo.appetite_nm}}</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="table_list">
          <h3 class="tb_title">약재 정보</h3>
          <table class="list no_view">
            <colgroup>
              <col width="12.5%" />
              <col width="12.5%" />
              <col width="12.5%" />
              <col width="12.5%" />
            </colgroup>
            <thead>
              <tr>
                <th>약재명</th>
                <th>이명</th>
                <th>설명</th>
                <th>용량</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in medicineList"
                :key="index"
              >
                <td>
                  <span>{{ item.med_hrb_nm }}</span>
                </td>
                <td>
                  <span>{{ item.med_alias }}</span>
                </td>
                <td>
                  <span>{{ item.med_prfm }}</span>
                </td>
                <td>
                  <span>{{ item.medicine_use_qnty }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table_list">
          <h3 class="tb_title">추가 정보</h3>
          <table class="write">
            <colgroup>
              <col width="200" />
              <col width="30%" />
              <col width="200" />
              <col width="30%" />
            </colgroup>
            <tbody>
              <tr>
                <th>비방에 대한 설명 및 가감</th>
                <td colspan="3">
                  <span>{{formulaLibraryInfo.secret_prescription_adjust}}</span>
                </td>
              </tr>
              <tr>
                <th>참고사항</th>
                <td colspan="3">
                  <span>{{formulaLibraryInfo.remarks}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table_list">
          <h3 class="tb_title">리뷰</h3>
          <table class="list">
            <colgroup>
              <col width="200" />
              <col width="*" />
              <col width="200" />
            </colgroup>
            <tbody>
              <tr>
                <th>별점</th>
                <th>평가</th>
                <th>등록자</th>
              </tr>
              <tr v-if="reviewList.length == 0">
                <td colspan="3"><span>데이터가 없습니다.</span></td>
              </tr>
              <tr v-for="(item1, index) in reviewList"
                :key="index"
              >
                <td>
                  <StarRating :rating="item1.star_rating" />
                </td>
                <td class="al"><span>{{item1.review_content}}</span></td>
                <td><span>{{item1.nick_nm}}</span></td>
              </tr>
            </tbody>
          </table>
          <Pagination :pageInfo="pageInfo"  @clickPage="fn_movePage" v-show="pagingShow"/>
        </div>

        <div class="flex gap8">
          <button class="btn btn_md btn_brown btn_outline" @click="fn_click_voteType(1)">😇 추천</button>
          <button class="btn btn_md btn_gray btn_outline" @click="fn_click_voteType(0)">👿 비추천</button>
        </div>

        <div class="bottom_box bn">
          <button class="btn btn_md btn_darkbrown" @click="fn_move_listPage">
            목록
          </button>
        </div>
      </article>
    </section>
    <alert-modal
          :id="'alert'"
          :text="showAlertMsg"
          :btnRight="'확인'"
          :oneBtn="false"
          :isShow="showAlert"
          :className="'btn_brown'"
          v-on:update:showSetting="fn_showSet"
      />
  </div>
</template>

<script>

import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";
import StarRating from "@/components/common/StarRating.vue";
import Pagination from "@/components/AdminPagination.vue"
import AlertModal from "@/modal/common/alertModal.vue"
import alertutill from "@/mixin/alertModalUtill";

export default {
  components: {
    StarRating,
    Pagination,
    AlertModal
  },
  mixins: [commonUtil,alertutill],
  data() {
    return {
      secret_prescription_seq : '',
      clinic_doctor_id : '',
      formulaLibraryInfo : {},
      medicineList : [],
      reviewList : [],
      pageInfo : {
        page : 1,
        pageSize : 10,
        totPage : 0
      },
      pagingShow : false,
    };
  },
  created(){

    let item = this.$store.getters['detailSearchInfo/getSearchInfo'];
    console.log("###### created :%o",item);
    this.clinic_doctor_id = item.clinic_doctor_id;
    this.secret_prescription_seq = item.secret_prescription_seq;

    console.log("@@@@@@ this.clinic_doctor_id :"+this.clinic_doctor_id);
    console.log("@@@@@@ this.secret_prescription_seq :"+this.secret_prescription_seq);
  },
  mounted(){
    this.fn_search();
  },
  methods: {
    fn_search(){

          //환자seq 정보 셋팅
          let param = new Object();
          param.secret_prescription_seq = this.secret_prescription_seq;
          param.clinic_doctor_id = this.clinic_doctor_id;
          param.pageInfo = this.pageInfo;

          //내 비방 정보 상세조회
          axios
              .post("/api/user/hanidata/getFormulaLibraryDetail", param)
              .then((res) => {
                  console.log("@@@@ res : %o",res);
                  this.formulaLibraryInfo = res.data.formulaLibraryInfo;
                  this.medicineList = res.data.medicineList;
                  
                  this.pageInfo.totPage = res.data.reviewTotalCnt;
                  this.reviewList = res.data.reviewList;

                  if(this.pageInfo.totPage> 0){
                    this.pagingShow = true;                          
                  } 

              })
              .catch((err) => console.log(err));
    },
    fn_move_listPage() {
      this.$store.dispatch('detailSearchInfo/setSearchId', '');
      this.$store.dispatch('detailSearchInfo/setStatus', '');
      this.$router.push("/hanidata/formulaLibraryList");
    },
    fn_movePage(page){

      this.pageInfo.page = page;

      let param = new Object();
      param.secret_prescription_seq = this.secret_prescription_seq;
      param.clinic_doctor_id = this.clinic_doctor_id;
      param.pageInfo = this.pageInfo;
      
      axios
        .post("/api/user/board/getScretPrescriptonReview", param)
        .then((res) => {
            console.log("@@@@ res : %o",res);

            this.reviewList = res.data.reviewList;

            this.pageInfo.totPage = res.data.reviewTotalCnt;
            
            if(this.pageInfo.totPage> 0){
                this.pagingShow = true;                          
            } 
        })
        .catch((err) => console.log(err));
    },
    fn_click_voteType(type){

      let param = new Object();
      param.secret_prescription_seq = this.secret_prescription_seq;
      param.clinic_doctor_id = this.clinic_doctor_id;
      param.vote_user_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];
      param.vote_type = type;

      if(param.clinic_doctor_id == param.vote_user_id){
        let msg = "내 비방은 추천할 수 없습니다.";
        this.fn_open_alert(msg); 
        return;
      }

      axios
        .post("/api/user/board/regtVoteType", param)
        .then((res) => {
            console.log("@@@@ res : %o",res);
            let result = res.data.result;

            if(result == 'ok'){
              let msg = "추천되었습니다.";
              this.fn_open_alert(msg); 
            }else{
              let msg = "이미 추천했습니다";
              this.fn_open_alert(msg); 
            }

        })
        .catch((err) => console.log(err));
    },
  }
};
</script>
